import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowRight, Mail, Menu, UserCircle2, X } from "lucide-react";
import { mediaUrl, navItems } from "@/lib/api";
import { useAuth } from "@/hooks/useAuth";

export const Header = ({ settings }) => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();
  const { user } = useAuth();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <div className="topbar">
        <div className="container topbar-in">
          <span>{settings.tagline || "For the people who build our region."}</span>
          <span className="top-contact" data-testid="topbar-contact">
            <Mail size={13} /> {settings.email} <span>·</span> <span>{settings.phone}</span>
            <span>·</span>
            <Link to={user ? "/account" : "/login"} className="top-login" data-testid="topbar-login-link"><UserCircle2 size={13} /> {user ? "My account" : "Member login"}</Link>
          </span>
        </div>
      </div>
      <header className={scrolled ? "header scrolled" : "header"}>
        <div className="container header-in">
          <Link to="/" className="brand" data-testid="site-logo-link">
            {settings.logo ? <img src={mediaUrl(settings.logo)} alt="" className="brand-logo" data-testid="site-logo-image" /> : <span className="brand-mark">D</span>}
            <span>
              <b>{settings.short_name || "DCEA"} Hubli–Dharwad</b>
              <small>{settings.association_name}</small>
            </span>
          </Link>
          <button className="mobile-menu" onClick={() => setOpen(!open)} data-testid="mobile-menu-button" aria-label="Menu">
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
          <nav className={open ? "nav open" : "nav"}>
            {navItems.map(([label, url]) => (
              <Link
                key={url}
                to={url}
                className={pathname === url ? "active" : ""}
                onClick={() => setOpen(false)}
                data-testid={`nav-${url.slice(1) || "home"}`}
              >
                {label}
              </Link>
            ))}
            <Link to={user ? "/account" : "/login"} className="nav-login" onClick={() => setOpen(false)} data-testid="header-login-link">{user ? "My account" : "Login"}</Link>
            <Link className="nav-cta" to={user ? "/account" : "/membership"} onClick={() => setOpen(false)} data-testid="header-member-cta">
              {user ? "Dashboard" : "Become a member"} <ArrowRight size={15} />
            </Link>
          </nav>
        </div>
      </header>
    </>
  );
};
